window.Wishlist = (function () {
  var STORAGE_KEY = 'shopify_wishlist';

  /* ── Storage helpers ── */
  function getAll() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveAll(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function has(handle) {
    return getAll().some(function (i) { return i.handle === handle; });
  }

  function add(item) {
    var list = getAll();
    if (!list.some(function (i) { return i.handle === item.handle; })) {
      list.push(item);
      saveAll(list);
    }
  }

  function remove(handle) {
    saveAll(getAll().filter(function (i) { return i.handle !== handle; }));
  }

  function toggle(item) {
    if (has(item.handle)) { remove(item.handle); return false; }
    else { add(item); return true; }
  }

  function count() { return getAll().length; }

  /* ── Header badge ── */
  // function updateBadge() {
  //   var badge = document.querySelector('.wl-count-badge');
  //   var icon  = document.querySelector('.wl-header-icon');
  //   if (!badge) return;
  //   var n = count();
  //   badge.textContent = n;
  //   if (n > 0) {
  //     badge.classList.add('visible');
  //     if (icon) icon.classList.add('wl-has-items');
  //   } else {
  //     badge.classList.remove('visible');
  //     if (icon) icon.classList.remove('wl-has-items');
  //   }
  // }

  function updateBadge() {
  var n = count();
  document.querySelectorAll('.wl-count-badge').forEach(function(badge) {
    badge.textContent = n;
    if (n > 0) {
      badge.classList.add('visible');
    } else {
      badge.classList.remove('visible');
    }
  });
  document.querySelectorAll('.wl-header-icon').forEach(function(icon) {
    if (n > 0) {
      icon.classList.add('wl-has-items');
    } else {
      icon.classList.remove('wl-has-items');
    }
  });
}

  /* ── Toast ── */
  function showToast(msg) {
    var t = document.getElementById('wl-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 2500);
  }

  /* ── Wishlist buttons (product / collection) ── */
  function initButtons() {
    document.querySelectorAll('[data-wl-btn]').forEach(function (btn) {
      var handle = btn.dataset.wlHandle;
      var label  = btn.querySelector('.wl-btn-label');

      /* set initial state */
      if (has(handle)) {
        btn.classList.add('wl-added');
        if (label) label.textContent = 'Wishlisted';
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = {
          handle: handle,
          title:  btn.dataset.wlTitle,
          image:  btn.dataset.wlImage,
          url:    btn.dataset.wlUrl,
          price:  btn.dataset.wlPrice
        };
        var added = toggle(item);
        btn.classList.toggle('wl-added', added);
        if (label) label.textContent = added ? 'Wishlisted' : 'Add to Wishlist';
        showToast(added ? '❤️ Added to wishlist' : 'Removed from wishlist');
        updateBadge();
      });
    });
  }

  /* ── Wishlist page renderer ── */
  function renderPage() {
    var grid = document.getElementById('wl-page-grid');
    if (!grid) return;
    var items = getAll();
    grid.innerHTML = '';

    if (items.length === 0) {
      grid.innerHTML = '<p class="wl-page-empty">Your wishlist is empty. <a href="/collections/all">Continue shopping</a></p>';
      return;
    }

    items.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'wl-card';
      card.innerHTML =
        '<a href="' + item.url + '">' +
          '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' +
        '</a>' +
        '<div class="wl-card-body">' +
          '<a href="' + item.url + '" class="wl-card-title">' + item.title + '</a>' +
          '<div class="wl-card-price">' + (item.price || '') + '</div>' +
          '<button class="wl-card-remove" data-handle="' + item.handle + '">✕ Remove</button>' +
        '</div>';
      grid.appendChild(card);
    });
      
    /* remove buttons */
    grid.querySelectorAll('.wl-card-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        remove(btn.dataset.handle);
        renderPage();
        updateBadge();
      });
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    updateBadge();
    initButtons();
    renderPage();
  });

  return { has: has, add: add, remove: remove, toggle: toggle, count: count };
})();